import getField from '@form/formGenerator'

export const paymentModeSaveUrl = `${import.meta.env.VITE_API_URL}/api/payment-modes`

export const paymentModeFormObject = {
  id: null,
  code: '',
  name: null,
  description: null,
  logo: null,
  isActive: false,
  isLive: false,
  liveConfig: {},
  testConfig: "",
  mission: null
}

const paymentModeFormFields = (step, paymentModeFormObject, updateFormObject, updateFormObjectProp, saveForm, errors, isLoading, t) => {
  const fields = []
  fields['common'] = [
    {
      type: 'select',
      name: 'code',
      label: t('labels.code'),
      value: paymentModeFormObject.code,
      key: 'paymentModeFormObject-code',
      cssClass: 'page-type column is-12',
      options: [{ label: 'monetico', value: 'CM_CIC' }],
      disabled: false,
      isRequired: true
    },
    {
      type: 'text',
      name: 'name',
      label: t('labels.name'),
      value: paymentModeFormObject.name,
      key: 'paymentModeFormObject-name',
      cssClass: 'column is-12',
      isRequired: true
    },
    {
      type: 'hugerte',
      config: 'min',
      name: "description",
      cssClass: 'column is-12',
      disabled: false,
      label: t('labels.description'),
      initialValue: paymentModeFormObject.description,
      isRequired: true,
      key: 'paymentModeFormObject-description',
    },
    {
      type: 'file',
      name: 'logo',
      cssClass: 'column is-12 logo',
      key: 'paymentModeFormObject-logo',
      label: t('labels.logo'),
      targetUrl: `${import.meta.env.VITE_API_URL}/api/push/temp-files`,
      blobPoster: paymentModeFormObject.logo,
      id: `logo-${paymentModeFormObject.id ?? 'new'}`,
      isRequired: true
    },
    {
      type: 'switcher',
      name: 'isActive',
      label: t('labels.is_active'),
      value: paymentModeFormObject.isActive,
      cssClass: 'column is-12',
      key: 'paymentModeFormObject-isActive',
      id: `isActive-${paymentModeFormObject.id ?? 'new'}`,
    },
    {
      type: 'switcher',
      name: 'isLive',
      label: t('labels.is_live'),
      value: paymentModeFormObject.isLive,
      cssClass: 'column is-12',
      key: 'paymentModeFormObject-isLive',
      id: `isLive-${paymentModeFormObject.id ?? 'new'}`,
    }
  ]

  fields['CM_CIC'] = [{
    type: 'text',
    name: 'liveConfig.mac',
    label: t('labels.mac_key'),
    value: paymentModeFormObject.liveConfig.mac,
    key: 'paymentModeFormObject-mac',
    cssClass: 'column is-12'
  }, {
    type: 'text',
    name: 'liveConfig.companyCode',
    label: t('labels.company_code'),
    value: paymentModeFormObject.liveConfig.companyCode,
    key: 'paymentModeFormObject-companyCode',
    cssClass: 'column is-12'
  }, {
    type: 'text',
    name: 'liveConfig.tpe',
    label: t('labels.tpe'),
    value: paymentModeFormObject.liveConfig.tpe,
    key: 'paymentModeFormObject-tpe',
    cssClass: 'column is-12'
  }]

  fields['submit'] = [
    {
      type: 'button',
      buttons: true,
      callback: saveForm,
      cancel: false,
      validateText: t('actions.save'),
      cssClassParent: 'column is-12',
      cssClassValidate: 'button is-blue',
      validateIcon: 'icon-done',
      key: 'paymentModeFormObject-form',
      isLoading
    },
    {
      type: 'hidden',
      name: 'id',
      value: parseInt(paymentModeFormObject.id),
      key: 'paymentModeFormObject-id'
    }
  ]


  return fields[step].map(function (field) {
    return getField({ ...field, error: errors[field.name] ? errors[field.name].errors : '' }, updateFormObject, updateFormObjectProp)
  })
}

export default paymentModeFormFields